import { Environment as CommonEnvironment } from 'modules/Common/Fields'
import { useResetPipelineField } from 'modules/Common/Fields/Environment/hooks/resetPipelineField'

export const Environment = () => {
  const onChange = useResetPipelineField()

  return (
    <CommonEnvironment
      data-testid="create-schedule-environment"
      onChange={onChange}
    />
  )
}
